import Colors from "../../../utilstyle";
import COLORS from "../../../../../UI/Theme/colors";
import { Theme } from "@material-ui/core/styles";

const style: any = (theme: Theme): any => ({
	container: {
		width: "100%",
	},
	root: {
		padding: 7,

		"&:hover": {
		  backgroundColor: "transparent",
		},
	},
	icon: {
		height: 20,
		width: 20,
		borderRadius: 2,
		boxShadow: "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
		backgroundColor: "#FFFF",
		backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
		"$root.Mui-focusVisible &": {
			outline: "2px auto rgba(19,124,189,.6)",
			outlineOffset: 2,
		},
		"input:hover ~ &": {
			backgroundColor: "#ebf1f5",
		},
		"input:disabled ~ &": {
			boxShadow: "none",
			background: "rgba(206,217,224,.5)",
			opacity:"0.5"
		},
	},
	checkedIcon: {
		height: 20,
		width: 20,
		borderRadius: 2,            
		border: "1px solid rgb(58, 145, 232)",
		boxShadow: "0px 1px 4px 0px rgba(21, 118, 214, 0.15)",
		backgroundColor: "#f0f8ff",
		backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
		"&:before": {
			display: "block",
			height: 20,
			width: 20,
			backgroundImage:
			"url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18'%3E%3Cpath" +
			" d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
			"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='rgb(58, 145, 232)' /%3E%3C/svg%3E\")",
			content: "\"\"",
		},
		"input:hover ~ &": {
			backgroundColor: "#ebf1f5",
		},
	},
	input: {
		backgroundColor: Colors.BackgroundColor,
		border: `1px solid ${Colors.BorderColor}`,
		borderRadius: 2,
		width: "100%",
		fontSize: "0.875rem",
		padding: "7px 12px",
		"box-sizing": "border-box",
	},
	inputInput: {
		padding: theme.spacing(1, 1, 1, 0),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		transition: theme.transitions.create("width"),
		maxWidth: "100%",
		fontSize: 14,
		height: 40,
		width: 396,
		fontWeight: "normal" as const,
		backgroundColor: "rgba(255, 255, 255, 0)",
		border: "1px solid rgb(208, 213, 218)",
		borderRadius: 2,
		"box-sizing": "border-box",
	},
	inputElement: {
		"&:hover": {
			border: "1px solid rgb(134, 142, 150)",
		},
		"&.Mui-focused": {
			border: "1px solid rgb(58, 145, 232)",
		},
		"&.Mui-disabled": {
			border: "1px solid rgb(208, 213, 218)",
		},
	},
	search: {
		position: "relative" as const,
		borderRadius: 2,
		backgroundColor: COLORS.WHITE,
		height: "max-content",
	},
	searchIcon: {
		padding: "0px 13px",
		height: "100%",
		position: "absolute" as const,
		pointerEvents: "none" as const,
		display: "flex",
		alignItems: "center" as const,
		justifyContent: "center" as const,
	},
	filterButton: {
		border: "2px solid #1576d6",
		backgroundColor: COLORS.WHITE,
		color: COLORS.DARK_GRAY,
		padding: "7px 12px 8px 12px",
		fontWeight: theme.typography.fontWeightMedium,
		"&:hover": {
			border: "1px solid #868e96",
			backgroundColor: COLORS.WHITE,
		},
		minWidth: 90,
		justifyContent: "flex-start",
		height: "40px",
		borderRadius: "5px"
	},
	filterText: {
		color: "#1576d6",
	},
	pagination: {
		float: "left",
		paddingTop: "20px",
	},
	norowsContent:{
		display:"flex",
		justifyContent:"center",
		padding:"20px"
	},
	tableRow: {
		padding: "14px 40px 14px 0px",
		"&:hover": {
			backgroundColor: "#F0F8FF"
		}
	},
	tableColumn: {
		borderBottom: 0
	},

});

export default style;